import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { Markdown } from 'site-modules/personalized-search/components/markdown/markdown';

export function Answer({ componentParams, onRendered = noop }) {
  const { answerText } = componentParams;

  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return (
    <div className="answer base-inner-width bg-transparent px-1 px-md-0_5 px-lg-0 mx-md-auto my-2">
      <Markdown items={[{ data: { content: answerText } }]} />
    </div>
  );
}

Answer.propTypes = {
  componentParams: PropTypes.shape({
    answerText: PropTypes.string,
  }).isRequired,
  onRendered: PropTypes.func,
};
